// extracted by mini-css-extract-plugin
export var badge = "ai-image-badge-module--badge--ae1f9";
export var compact = "ai-image-badge-module--compact--17d03";
export var icon = "ai-image-badge-module--icon--d30ed";